module.exports = __webpack_public_path__ + "static/media/seafood@3x.ee2f976e.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/seafood@3x.png
// module id = 675
// module chunks = 1